import isMobile from 'is-mobile';
import query from './device.graphql';

export const getDevice = ua => (isMobile({ ua }) ? 'mobile' : 'desktop');

export const setDevice = (cache, req) => {
  const device = req ? req.headers['user-agent'] : null;
  cache.writeQuery({
    query,
    data: { device: getDevice(device) },
  });
};
